module.exports = {
    "removeDescription": `Press Delete to remove tag.`,
    "removeButtonLabel": `Remove`
};


//# sourceMappingURL=en-US.main.js.map
